import React from 'react';
import { Card } from './Card';
import { Diff } from '../Diff';
import { getDiff, getComparePresetLabel } from '../../model/Diff';
import { AttentionIcon } from '../icons/AttentionIcon';
import { TrafficIcon } from '../icons/TrafficIcon';
import { Information } from '../Information';
import { ComparePreset } from '../../model/datePicker/types';
import { t } from '../../i18n';

const PeakTimeCard = ({ hour, total, previousTotal, comparePreset }: Props) => {
  return (
    <Card className="card-border-shadow-success">
       <div className="card-body">
        <div className="d-flex align-items-center">
          <Information id="peakTime" content={<span>{t('cards.peakTime')}</span>} />
          <Information id="peakTime" showMore={true} className="ms-2" />
        </div>
        <small className="d-flex align-items-center">
          <Diff value={getDiff(total, previousTotal)} />
          <div className="text-muted ms-2">{getComparePresetLabel(comparePreset)} ({previousTotal})</div>
        </small>
        <div className="row justify-content-center mt-4">
          <div className="col-6">
            <div className="d-flex flex-column align-items-center">
              <AttentionIcon />
              <h4 className="mb-0 mt-2">{hour}</h4>
              <div className="d-flex align-items-center">
                <Information id="peakHour" content={<small className="text-muted me-2">{t('cards.peakHour')}</small>} />
                <Information id="peakHour" showMore={true} />
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex flex-column align-items-center">
              <TrafficIcon />
              <h4 className="mb-0 mt-2">{total}</h4>
              <div className="d-flex align-items-center">
                <Information id="totalPeople" content={<small className="text-muted me-2">{t('cards.totalPeople')}</small>} />
                <Information id="totalPeople" showMore={true} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>);
}

interface Props {
  hour: string,
  total: number,
  previousTotal: number,
  comparePreset?: ComparePreset
}

export { PeakTimeCard };